import { RoundedBox } from '@react-three/drei'
import { Helper } from '../../../../classes/helper'
import { useMeasures } from '../../../../hooks/state/useMeasures'
import { useRoof } from '../../../../hooks/state/useRoof'
import { CachedMeshPhysicalMaterial } from '../../../material/cachedMeshPhysicalMaterial'
import { FrontBarDefault } from '../model/bar'
import { FrontBarClassic } from '../model/bar/FrontBarClassic'
import { FrontBarRound } from '../model/bar/FrontBarRound'
import { FrontBarSquare } from '../model/bar/FrontBarSquare'
import { StaticsCarrier } from './StaticsCarrier'

export const FrontBar = (): JSX.Element => {
  const {
    userWidth,
    depth,
    frontBarLogTyp,
    verandaTyp,
    userAngle,
    hasStaticLog,
    eaves,
    eavesWidth,
    staticLogPosition,
    offsetRoofLog,
    schwelleSize,
    userHeight,
    attachedSize,
  } = useMeasures()
  const { color } = useRoof()

  const width = verandaTyp.bar.width + 0.02
  const depthBar = verandaTyp.bar.depth

  const height =
    userHeight -
    Helper.calculateTriangleSideLength(
      userAngle,
      90,
      depth - attachedSize.z - schwelleSize.depth
    ).a

  const RoofLogHeight = Helper.calculateTriangleSideLength(
    userAngle,
    90,
    verandaTyp.roofBar.width
  )
  return (
    <group position={[0, height, depth!]} castShadow={true}>
      <mesh
        position={[
          0,
          -schwelleSize.width / 2 + RoofLogHeight.b,
          -schwelleSize.depth / 2 - verandaTyp.log.depth + 0.02,
        ]}
        castShadow={true}
        receiveShadow={false}
      >
        <RoundedBox
          args={[userWidth!, schwelleSize.width, schwelleSize.depth]}
          radius={0.0001}
          smoothness={0.5}
          castShadow={true}
          matrixWorldAutoUpdate={undefined}
          getObjectsByProperty={undefined}
          getVertexPosition={undefined}
        >
          <CachedMeshPhysicalMaterial color={color} />
        </RoundedBox>
      </mesh>

      {eaves && !hasStaticLog && (
        <mesh
          position={[
            0,
            Helper.calculateTriangle(eavesWidth, userAngle, 90).b -
              (hasStaticLog ? staticLogPosition : 0.06),
            -eavesWidth - verandaTyp.log.depth / 2,
          ]}
          castShadow={true}
          receiveShadow={true}
        >
          <boxGeometry args={[userWidth!, 0.12, verandaTyp.log.depth]} />
          <CachedMeshPhysicalMaterial color={color} />
        </mesh>
      )}

      {hasStaticLog && (
        <StaticsCarrier
          height={staticLogPosition}
          depth={verandaTyp.log.depth}
          isBackside={false}
        />
      )}
      <group position={[0, 0, -width]}>
        {frontBarLogTyp === 'eckig' && (
          <FrontBarSquare height={depthBar} width={width} />
        )}
        {frontBarLogTyp === 'rund' && (
          <FrontBarRound height={depthBar} width={width} />
        )}
        {frontBarLogTyp === 'klassisch' && (
          <FrontBarClassic height={depthBar} width={width} />
        )}
        {frontBarLogTyp === 'kasten' && (
          <FrontBarDefault width={width} height={depthBar} />
        )}
        {/* {frontBarLogTyp === 'fantasy' && (
        <FrontBarFantasy width={width} height={depthBar} angel={userAngle} />
      )} */}
      </group>
    </group>
  )
}
